<script lang="ts">
    import { _ } from "svelte-i18n";
    import Score from "../../Score.svelte";
    import type { ModelSegmentInfoManager } from "./ModelSegmentInfoManager";
    import type { LocationData } from "../../api/trips/data/LocationData";
    import { appManager } from "../../AppManager";

    export let manager: ModelSegmentInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    let showCyclingScoreStore = manager.getShowCyclingScoreStore();
    let showRelevantLocationsStore = manager.getShowRelevantLocationsStore();
    let selectedSegment = manager.getSelectedSegmentStore();
    let selectionStore = manager.getSelectionStore();

    let count: number = 0;
    let safetyScore: number = 1.5;
    let fromLocations: LocationData[] = [];
    let toLocations: LocationData[] = [];

    $: if (typeof $selectedSegment !== "undefined") {
        const forward = $selectedSegment.forward;
        const segment = $selectedSegment.data;

        if (forward) {
            safetyScore =
                Math.round(
                    Number(
                        segment.tags.get("_score:bicycle:comfort:forward") ??
                            "0",
                    ) * 10,
                ) / 10;
            segment.forwardTrips.forEach((f) => {
                f.startLocations.forEach((s) => {
                    if (fromLocations.findIndex((x) => x.id == s.id) !== -1)
                        return;

                    fromLocations.push(s);
                });
                f.endLocations.forEach((s) => {
                    if (toLocations.findIndex((x) => x.id == s.id) !== -1)
                        return;

                    toLocations.push(s);
                });
            });
        } else {
            safetyScore =
                Math.round(
                    Number(
                        segment.tags.get("_score:bicycle:comfort:backward") ??
                            "0",
                    ) * 10,
                ) / 10;
            segment.backwardTrips.forEach((f) => {
                f.startLocations.forEach((s) => {
                    if (fromLocations.findIndex((x) => x.id == s.id) !== -1)
                        return;

                    fromLocations.push(s);
                });
                f.endLocations.forEach((s) => {
                    if (toLocations.findIndex((x) => x.id == s.id) !== -1)
                        return;

                    toLocations.push(s);
                });
            });
        }

        count = 0;
        const trips = forward ? segment.forwardTrips : segment.backwardTrips;
        if (typeof trips !== "undefined") {
            trips.forEach((t) => {
                count += t.trips?.length ?? 0;
            });
        }
    }

    const onSelectedLocation = (locationId: number): void => {
        $selectionStore = { locationId: locationId };
    };
</script>

<div class="card-body p-4">
    <p class="mb-2 small">
        {$_(`${$modelTranslationKeyStore}.segment.p1.part1`)}
        <strong>{count}</strong>
        {$_(`${$modelTranslationKeyStore}.segment.p1.part2`)}
    </p>
    {#if $showCyclingScoreStore}
        <div class="my-3">
            <Score score={safetyScore} class="score-main">
                {safetyScore}
            </Score>
        </div>
    {/if}

    {#if $showRelevantLocationsStore}
        <div class="mb-2 small">
            {$_(`${$modelTranslationKeyStore}.segment.p2.part1`)}
            <ul>
                {#each fromLocations as location}
                    <li>
                        <a
                            href="{appManager.PublicUrl}?location={location.id}"
                            on:click={(e) => {
                                onSelectedLocation(location.id);
                                e.preventDefault();
                                return false;
                            }}>{location.tags.get("name") ?? "{no name}"}</a>
                    </li>
                {/each}
                {#each toLocations as location}
                    <li>
                        <a
                            href="{appManager.PublicUrl}?location={location.id}"
                            on:click={(e) => {
                                onSelectedLocation(location.id);
                                e.preventDefault();
                                return false;
                            }}>{location.tags.get("name") ?? "{no name}"}</a>
                    </li>
                {/each}
            </ul>
        </div>
    {/if}

    <p class="mb-2 text-muted small">
        {$_("segment.subtitle")}
    </p>
</div>

<style>
    .scores {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: 100px 120px;
        grid-template-columns: 50% 50%;
        padding: 10px;
        text-align: center;
    }
</style>
